import { render, staticRenderFns } from "./GatekeeperDashboard.vue?vue&type=template&id=3bba28ec&scoped=true&"
import script from "./GatekeeperDashboard.vue?vue&type=script&lang=js&"
export * from "./GatekeeperDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GatekeeperDashboard.vue?vue&type=style&index=0&id=3bba28ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bba28ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
